import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=070eec6a&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SportIcon: require('/var/web/bet777.es/components/sport/icon.vue').default,LiveWidgetCompetitions: require('/var/web/bet777.es/components/live/widget_competitions.vue').default})
